/**
 * Global Imports
*/

import React, { useEffect, useContext } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { ShowAbilityService } from '~/services/Ability';

/**
 * Local Imports
*/

import { AbilityContext } from '../../Providers/AbilityProvider';
import { ResourceManage } from '../../Widgets/ResourceManage';

/**
 * Exports
*/

/**
 * 
 */
export function IndexAbility(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'abilities',
      breadcrumbs: 'Abilities'
    });
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderIndex = () => (
    <div>Choose an ability.</div>
  );
  
  /** Output **/
  
  return (
    <ResourceManage
      group='abilities'
      context={ AbilityContext }
      service={ ShowAbilityService }
      renderIndex={ renderIndex }
    />
  );
}